export const _en = {
    toggleDeleted: {
        label: ""
    },
    firstRow: {
        addButton: {
            label: "Add"
        },
        modal: {
            label: "Resource category creation"
        }
    },
    secondRow: {
        addButon: {
            label: "Add"
        },
        modal: {
            label: "Resource type creation"
        }
    },
    thirdRow: {
        tabs: {
            propertie: {
                label: "Properties"
            },
            resources: {
                label: "Associated resources"
            }
        },
        duplicateButton: {
            label: "Duplicate"
        },
        addButton: {
            label: "Create"
        },
        editButton: {
            label: "Edit"
        }
    },
    dialog: {
        new: {
            title: "New"
        },
        edit: {
            title: "Edit",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        duplicate: {
            title: "Duplicate",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        delete: {
            warningTitle: "Would you like to delete: {{item}} ?"
        }
    }
};

export const _fr = {
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    firstRow: {
        addButton: {
            label: "Catégorie de ressources"
        },
        modal: {
            label: "Ajout d'une nouvelle catégorie de ressource"
        }
    },
    secondRow: {
        addButton: {
            label: "Type de ressources"
        },
        modal: {
            label: "Ajout d'un nouveau type de ressource"
        }
    },
    thirdRow: {
        tabs: {
            propertie: {
                label: "Propriétés"
            },
            resources: {
                label: "Ressources associées"
            }
        },
        duplicateButton: {
            label: "Dupliquer une ressource"
        },
        addButton: {
            label: "Ajout d'une nouvelle ressource"
        },
        editButton: {
            label: "Édition d'une ressource"
        }
    },
    dialog: {
        new: {
            title: "Nouveau"
        },
        edit: {
            title: "Édition d'une ressource",
            buttons: {
                save: "Éditer",
                cancel: "Annuler"
            }
        },
        duplicate: {
            title: "Duplication d'une ressource",
            buttons: {
                save: "Dupliquer",
                cancel: "Annuler"
            }
        },
        delete: {
            warningTitle: "Voulez vous supprimer : {{item}} ?"
        }
    }
};